<div class="spinner-wrapper" *ngIf="active">
	<div class="dimmer"></div>

	<div class="loading-bg">
		<div class="loader">
			<div class="wrapper"><div></div><div></div><div></div></div>
		</div>
	</div>
</div>
